import type { PropsWithChildren } from 'react';

import { Stack, Typography } from '@mui/material';

import { useApp } from '@system/app';

export const Servicing = (props: PropsWithChildren) => {
  const { flags, isAdm } = useApp();

  const maintenance_mode = flags?.find(
    item => item.name === 'maintenance_mode',
  );

  const { children } = props;

  if (!isAdm && maintenance_mode?.value === 'on') {
    return (
      <Stack
        width="100%"
        height="50vh"
        alignItems="center"
        justifyContent="center"
        gap={2}
      >
        <Typography variant="h2">Приносим извинения</Typography>
        <Typography variant="h3">
          Система находится на техническом обслуживании.
        </Typography>
      </Stack>
    );
  }

  return children;
};
